// import lodash from 'lodash';                //	lodash 工具库
import { axios } from '@/utils/request';    //  网络请求库
// import Store from '@/store/index.js';       //	加载状态管理
import Storage from 'store2';               //  本地存储
import util from "./util.js";               //	工具函数库

/**
 * 普通操作类库
 */
export default {

	/**
	 * 获得碎片数据
	 * @param {Object} option
	 */
	getBlockData(option) {
		let defaults = {
			flag: '', //	碎片标识
			success: (result) => { }, //  成功函数
			error: (result) => { }, //  失败函数
		};
		let options = Object.assign(defaults, option || {});
		axios.post('/public/block', {
			block_flag: options.flag,
		}).then(res => {
			if (res.ret == '0') {
				options.success(res);
			} else {
				options.error(res);
			}
		}).catch(err => {

		});
	},

	/**
	 * 获得区域列表
	 * @param {*} option 
	 */
	getAreaListData(option) {
		let defaults = {
			success: (result) => { }, //  成功函数
			error: (result) => { }, //  失败函数
		};
		let options = Object.assign(defaults, option || {});
		axios.post('/public/elementui-area').then(res => {
			if (res.ret == '0') {
				options.success(res);
			} else {
				options.error(res);
			}
		}).catch(err => {
			options.error(err);
		});
	},

	/**
	 * 获得文章内容
	 */
	getArticleData(option) {
		let defaults = {
			article_id: '', 	//	文章ID
			success: (result) => { }, //  成功函数
			error: (result) => { }, //  失败函数
		};
		let options = Object.assign(defaults, option || {});
		axios.post('/article/show', {
			article_id: options.article_id,
		}).then(res => {
			if (res.ret == '0') {
				options.success(res);
			} else {
				options.error(res);
			}
		}).catch(err => {

		});
	}

}
